import styled from "styled-components";
import { size, palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 25px;
  border: 2px solid;
  border-color: ${(props) => {
    switch (props.$borderColor) {
      case "declinedThemeColour":
        return palette("tracking", 3);
      case "white":
        return palette("color", 16);
      case "mainThemeColor":
      default:
        return palette("tracking", 2);
    }
  }};
  padding: 20px 5px;
  margin-bottom: 30px;

  @media only screen and (min-width: ${size("S")}) {
    padding: 20px 15px;
  }
`;
